import { NbMenuItem } from '@nebular/theme';

export class MenuItems {

  public getMenuItems(organizationId?: string, groupId?: string) {
    if (groupId) {
      const GROUP_MENU_ITEMS: NbMenuItem[] = [
        {
          title: 'Dashboard',
          icon: 'home-outline',
          link: `/g/${groupId}/dashboard`,
          home: true,
        },
        {
          title: 'Relatórios Por Grupo',
          group: true,
        },
        {
          title: 'Detalhado - POS',
          link: `/g/${groupId}/reports/pos-detailed`,
          icon: 'smartphone-outline',
        },
      ];
      return GROUP_MENU_ITEMS;
    }

    const ORG_MENU_ITEMS: NbMenuItem[] = [
      {
        title: 'Dashboard',
        icon: 'home-outline',
        link: `/o/${organizationId}/dashboard`,
        home: true,
      },
      {
        title: 'Relatórios',
        group: true,
      },
      {

        title: 'Vendas',
        link: `/o/${organizationId}/reports/sales`,
        icon: 'shopping-bag-outline',
      },
      {

        title: 'Recebimentos',
        link: `/o/${organizationId}/reports/receivables`,
        icon: 'calendar-outline',
      },
      {
        title: 'Transações',
        link: `/o/${organizationId}/reports/transactions`,
        icon: 'credit-card-outline',
      },
      {

        title: 'Detalhado - POS',
        link: `/o/${organizationId}/reports/pos-detailed`,
        icon: 'smartphone-outline',
      },
      {

        title: 'PIX',
        link: `/o/${organizationId}/reports/pix-transactions`,
        icon: 'browser-outline',
      },
      {

        title: 'Pedidos',
        link: `/o/${organizationId}/reports/orders`,
        icon: 'browser-outline',
      },
    ];
    return ORG_MENU_ITEMS;
  }
}

